import { Box, styled } from '@mui/material';
import { PROGRESS_CARD_SIZES } from '../constants';
import { StatisticSize, Trend } from '../types';

export const ProgressCardLabelWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: StatisticSize }>(({ theme, size = 'md' }) => {
  const sizeConfig = PROGRESS_CARD_SIZES[size] ?? PROGRESS_CARD_SIZES.md;

  return {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    fontSize: sizeConfig.labelFontSize,
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
  };
});

export const ProgressCardValueWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: StatisticSize }>(({ size = 'md' }) => {
  const sizeConfig = PROGRESS_CARD_SIZES[size] ?? PROGRESS_CARD_SIZES.md;

  return {
    fontSize: sizeConfig.valueFontSize,
    fontWeight: 600,
    lineHeight: 1.4,
  };
});

export const ProgressCardTag = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'trend',
})<{ trend?: Trend }>(({ theme, trend }) => {
  const getBackgroundColor = () => {
    if (trend === 'positive') return theme.palette.success.main;
    if (trend === 'negative') return theme.palette.error.main;
    return theme.palette.grey[500];
  };

  return {
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 1.5),
    borderRadius: 4,
    backgroundColor: getBackgroundColor(),
    color: theme.palette.common.white,
    fontSize: '0.75rem',
    fontWeight: 500,
  };
});

export const ProgressCardProgressLabel = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: StatisticSize }>(({ theme, size = 'md' }) => {
  const sizeConfig = PROGRESS_CARD_SIZES[size] ?? PROGRESS_CARD_SIZES.md;

  return {
    fontSize: sizeConfig.progressLabelFontSize,
    color: theme.palette.text.primary,
    lineHeight: 1.4,
  };
});

export const ProgressCardProgressValue = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: StatisticSize }>(({ theme, size = 'md' }) => {
  const sizeConfig = PROGRESS_CARD_SIZES[size] ?? PROGRESS_CARD_SIZES.md;

  return {
    fontSize: sizeConfig.progressLabelFontSize,
    color: theme.palette.text.secondary,
    lineHeight: 1.4,
  };
});
